import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [3.17614666774],
    [0.01353968419, 5.59313319619, 10213.285546211],
    [0.00089891645, 5.30650048468, 20426.571092422],
    [0.00005477201, 4.41630652531, 7860.4193924392],
    [0.00003455732, 2.69964470778, 11790.6290886588],
    [0.00002372061, 2.99377539568, 3930.2096962196],
    [0.00001664069, 4.2501893503, 1577.3435424478],
    [0.00001438322, 4.15745043958, 9683.5945811164],
    [0.00001317108, 5.18668219093, 26.2983197998],
    [0.00001200521, 6.15357115319, 30639.856638633],
    [0.00000769314, 0.81629615911, 9437.762934887],
    [0.0000076138, 1.9501470212, 529.6909650946],
    [0.00000707676, 1.06466707214, 775.522611324],
    [0.00000584836, 3.99839884762, 191.4482661116],
    [0.00000499915, 4.12340210074, 15720.8387848784],
    [0.00000429498, 3.58642859752, 19367.1891622328],
    [0.00000326967, 5.67736583705, 5507.5532386674],
    [0.00000326221, 4.59056473097, 10404.7338123226],
    [0.00000231937, 3.16251057072, 9153.9036160218],
    [0.00000179695, 4.65337915578, 1109.3785520934],
    [0.00000155464, 5.57043888948, 19651.048481098],
    [0.00000128263, 4.22604493736, 20.7753954924],
    [0.00000127907, 0.96209822685, 5661.3320491522],
    [0.00000105547, 1.53721191253, 801.8209311238],
    [0.00000099121, 0.83288185132, 213.299095438],
    [0.00000098804, 5.39389655503, 13367.9726311066],
    [0.00000088031, 3.88868860307, 9999.986450773],
    [0.00000085722, 0.35589249966, 3154.6870848956],
    [0.00000082094, 3.21596990826, 18837.49819713819],
    [0.00000071577, 0.11145739345, 11015.1064773348],
    [0.00000070239, 0.67458813282, 23581.2581773176],
    [0.00000056122, 4.24039855475, 7.1135470008],
    [0.00000050796, 0.24531603049, 11322.6640983044],
    [0.00000046111, 5.31576465717, 18073.7049386502],
    [0.00000044574, 6.06282201966, 40853.142184844],
    [0.00000042635, 1.7995542168, 7084.8967811152],
    [0.00000042594, 5.3287333721, 2352.8661537718],
    [0.00000041177, 0.36240972161, 382.8965322232],
    [0.00000035749, 2.70448479296, 10206.1719992102],
    [0.00000033893, 2.02347322198, 6283.0758499914],
    [0.00000033252, 2.10025596509, 27511.4678735372],
    [0.00000030172, 4.9419191989, 13745.3462390224],
    [0.0000002985, 4.02176977477, 10239.5838660108],
    [0.00000029252, 3.51392387787, 283.8593188652],
    [0.00000029138, 3.59230925768, 22003.9146348698],
    [0.00000028479, 2.22375414002, 1059.3819301892],
    [0.0000002626, 0.54067587552, 17298.1823273262],
    [0.00000024424, 2.70177493852, 8624.2126509272],
    [0.00000024322, 4.27814493315, 5.5229243074],
    [0.00000023739, 4.82870797552, 6872.6731195112],
    [0.00000020492, 0.58547075036, 38.0276726358],
    [0.00000020274, 3.79493637509, 14143.4952424306],
    [0.00000019069, 6.12025580313, 29050.7837433492],
    [0.00000018988, 4.13811500642, 4551.9534970588],
    [0.00000018269, 3.04740408477, 19999.97290154599],
    [0.00000017094, 3.5216152643, 31441.6775697568],
    [0.00000015885, 1.50067222283, 8635.9420037632],
    [0.00000013656, 4.41336292334, 3532.0606928114],
    [0.00000011807, 1.91250672543, 21228.3920235458],
    [0.00000011599, 5.81007422699, 19896.8801273274],
    [0.00000011048, 2.58361219075, 9786.687355335],
    [0.00000010955, 2.84562790076, 18307.8072320436],
    [0.00000010576, 0.85419784436, 10596.1820784342],
    [0.00000010105, 2.34270786693, 10742.9765113056],
];

const VSOP87_L1: Vsop87Element = [
    [10213.52943052898],
    [0.00095707712, 2.46424448979, 10213.285546211],
    [0.00014444977, 0.51624564679, 20426.571092422],
    [0.00000213374, 1.79547929368, 30639.856638633],
    [0.00000173904, 2.65535879443, 26.2983197998],
];

const VSOP87_L2: Vsop87Element = [
    [0.00054127076],
    [0.0000389146, 0.34514360047, 10213.285546211],
    [0.0000133788, 2.02011286082, 20426.571092422],
    [0.00000023836, 2.04592119012, 26.2983197998],
    [0.00000019331, 3.53527371458, 30639.856638633],
    [0.00000009984, 3.97130221102, 775.522611324],
    [0.00000007046, 1.51962593409, 1577.3435424478],
];

const VSOP87_L3: Vsop87Element = [
    [0.00000135742, 4.80389020993, 10213.285546211],
    [0.00000077846, 3.66876371591, 20426.571092422],
    [0.00000026023],
    [0.00000001214, 5.31970006917, 30639.856638633],
];

const VSOP87_L4: Vsop87Element = [
    [0.00000003209, 5.20514170164, 20426.571092422],
    [0.00000001714, 2.51099591706, 10213.285546211],
];

const VSOP87_L5: Vsop87Element = [[0.00000000118, 1.90548541922, 10213.285546211]];

const VSOP87_B0: Vsop87Element = [
    [0.05923638472, 0.26702775813, 10213.285546211],
    [0.00040107978, 1.14737178106, 20426.571092422],
    [0.00001011392, 1.08946123021, 30639.856638633],
    [0.00000149458, 6.25390296069, 18073.7049386502],
    [0.00000137788, 0.86020146523, 1577.3435424478],
    [0.00000129973, 3.67152483651, 9437.762934887],
    [0.00000119507, 3.70468812804, 2352.8661537718],
    [0.00000107971, 4.53903677647, 22003.9146348698],
    [0.00000092029, 1.53954562706, 9153.9036160218],
    [0.00000052982, 2.28138172277, 5507.5532386674],
    [0.00000045617, 0.72319641722, 10239.5838660108],
];

const VSOP87_B1: Vsop87Element = [
    [0.00513347602, 1.80364310797, 10213.285546211],
    [0.000043801, 3.38615711591, 20426.571092422],
    [0.00000199162],
    [0.00000196586, 2.53001197486, 30639.856638633],
    [0.00000014031, 2.27087044687, 9437.762934887],
    [0.00000012958, 1.50735622957, 18073.7049386502],
];

const VSOP87_B2: Vsop87Element = [[0.00022377665, 3.38509143877, 10213.285546211], [0.00000281739]];

const VSOP87_B3: Vsop87Element = [[0.00000646671, 4.99166565277, 10213.285546211]];

const VSOP87_B4: Vsop87Element = [];

const VSOP87_B5: Vsop87Element = [];

const VSOP87_R0: Vsop87Element = [
    [0.72334820905],
    [0.00489824185, 4.02151832268, 10213.285546211],
    [0.00001658058, 4.90206728012, 20426.571092422],
    [0.00001632093, 2.84548851892, 7860.4193924392],
    [0.00001378048, 1.128465906, 11790.6290886588],
    [0.00000498399, 2.58682187717, 9683.5945811164],
    [0.00000373958, 1.42314837063, 3930.2096962196],
    [0.00000263616, 5.5293818592, 9437.762934887],
    [0.00000237455, 2.55135903978, 15720.8387848784],
    [0.00000221983, 2.01346776772, 19367.1891622328],
    [0.00000125896, 2.72769833559, 1577.3435424478],
    [0.00000119467, 3.01975365264, 10404.7338123226],
    [0.00000085336, 3.98607953754, 19651.048481098],
    [0.00000076178, 1.59577224486, 9153.9036160218],
    [0.00000074347, 4.11957854039, 5507.5532386674],
    [0.00000042493, 3.81864530735, 13367.9726311066],
    [0.00000041904, 1.64273363458, 18837.49819713819],
    [0.0000003943, 5.39019422358, 23581.2581773176],
    [0.00000031274, 2.31806719544, 9999.986450773],
    [0.00000029042, 5.67739528728, 5661.3320491522],
    [0.00000027555, 5.72392407794, 775.522611324],
    [0.00000027283, 4.82151812709, 11015.1064773348],
    [0.00000019809, 0.53189326492, 27511.4678735372],
    [0.000000197, 4.96157560245, 11322.6640983044],
    [0.00000016215, 0.5645383429, 529.6909650946],
    [0.00000013567, 3.75530870628, 18073.7049386502],
    [0.0000001318, 3.37207825651, 13745.3462390224],
    [0.00000013079, 5.24353197586, 17298.1823273262],
];

const VSOP87_R1: Vsop87Element = [
    [0.00034551039, 0.89198710598, 10213.285546211],
    [0.00000234203, 1.77224942714, 20426.571092422],
    [0.00000023864, 1.11274502648, 9437.762934887],
    [0.00000010568, 4.59168210921, 1577.3435424478],
    [0.00000009124, 4.53540907003, 10404.7338123226],
];

const VSOP87_R2: Vsop87Element = [
    [0.00001406587, 5.0636639519, 10213.285546211],
    [0.00000015529, 5.47321687981, 20426.571092422],
];

const VSOP87_R3: Vsop87Element = [];

const VSOP87_R4: Vsop87Element = [];

const VSOP87_R5: Vsop87Element = [];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];
export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];
export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
